import { forwardRef } from 'react';
import { LucideProps, TableProperties } from 'lucide-react';

export interface ListViewIconProps extends LucideProps {
    /** Defaults to 1em; compact tabs and avatars can supply their own bounded size. */
    size?: number | string;
}

/** Canonical generic/table List View glyph; sizing follows its surrounding text unless explicitly provided. */
const ListViewIcon = forwardRef<SVGSVGElement, ListViewIconProps>(({ size = '1em', style, ...props }, ref) => (
    <TableProperties
        {...props}
        ref={ref}
        data-resource-icon='list-view'
        size={size}
        style={{
            flexShrink: 0,
            ...style,
            transform:
                style?.transform && style.transform !== 'none' ? `rotate(180deg) ${style.transform}` : 'rotate(180deg)',
        }}
    />
));
ListViewIcon.displayName = 'ListViewIcon';

export default ListViewIcon;
